export default type => {
  const actionCreator = payload => ({ type, payload })
  actionCreator.type = type
  return  actionCreator
}